export class OzReplyMailTemplate{
    constructor(){
        this.template_type = null;
        this.name = null;
        this.value = null;
        this.enable = null;
        this.lang = null;
    }
}